import React from "react";
import { RootState } from "@src/reducers/store";
import { useSelector } from "react-redux";
import { EditServiceUserDrawerModal } from "@src/components/organisms/modals/edit-service-user-drawer-modal/edit-service-user-drawer-modal";

export const EditServiceUserDrawer = () => {
  const showEditServiceUserDrawerModal = useSelector(
    (state: RootState) =>
      state.yourSlice.modals.editServiceUserDrawerModal.showModal,
  );

  return (
    <>{showEditServiceUserDrawerModal && <EditServiceUserDrawerModal />}</>
  );
};
